import { isEmpty, last } from 'ramda';

const PERMITED_FORMATS = ['video/mpeg4', 'video/mov', 'video/mp4', 'video/m4v', 'video/avi', 'video/quicktime'];
const MAX_SIZE_MB = 150;

const getFormatName = format => last(format.split('/'));

export const validationSchema = [
  {
    validateVideo: ({ size }) => size < MAX_SIZE_MB * 1024 * 1024,
    error: () => `should be less than ${MAX_SIZE_MB}Mb`,
    type: 'size',
  },
  {
    validateVideo: ({ type }) => PERMITED_FORMATS.includes(type),
    error: ({ type }) =>
      `${getFormatName(type)} not supported. Supported formats: ${PERMITED_FORMATS.map(getFormatName).join(', ')}`,
    type: 'format',
  },
];

export const validate = (video, schema) => {
  const errors = schema.reduce((errs, { validateVideo, error, type }) => {
    if (validateVideo(video)) return errs;
    return [...errs, `${type}: ${error(video)}`];
  }, []);

  return { errors, valid: isEmpty(errors) };
};



// WEBPACK FOOTER //
// ./src/forms/videoForm.js